import { OPEN_MODAL_CHANGE_STATUS } from '../actionTypes';
import { creditsActions } from '../reducer';

export default (value) => creditsActions[OPEN_MODAL_CHANGE_STATUS](value);
